import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
} from "@material-ui/core";
import { isNullOrUndefined } from "../../utils/CommonFunctions";
import RxTypography from "../RxTypography";
import styles from "./RxProductPriceDetail.module.css";

interface RxProductPriceDetailProps {
	price: number;
	priceWithDiscount: number;
	additionPrice: number;
	minNumberOfProduct: number;
	maxNumberOfProduct: number;
	kdvIncluded: boolean;
	discount: number;
}

const RxProductPriceDetail = (props: RxProductPriceDetailProps) => {
	const calculatePrice = (index: number, withDiscount: boolean): number => {
		if (withDiscount) {
			return (
				props.priceWithDiscount +
				props.additionPrice * (index - props.minNumberOfProduct)
			);
		}
		return (
			props.price + props.additionPrice * (index - props.minNumberOfProduct)
		);
	};

	return (
		<>
			<Table className={styles.tableMinWidth}>
				<TableHead className={styles.tableBackground}>
					<TableRow>
						<TableCell className={styles.bold} align="center">
							Adet
						</TableCell>
						<TableCell className={styles.bold} align="center">
							Fiyat
						</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{Array.from(
						{
							length:
								props.maxNumberOfProduct - props.minNumberOfProduct + 1,
						},
						(_, i) => props.minNumberOfProduct + i
					).map((item) => {
						return (
							<TableRow key={item}>
								<TableCell align="center">
									<RxTypography
										component="span"
										variant="body1"
										align="center"
										label={item}
									/>
								</TableCell>
								<TableCell align="center">
									<RxTypography
										component="span"
										variant="body1"
										align="center"
										label={
											calculatePrice(item, false).toFixed(2) + " TL"
										}
										className={
											props.priceWithDiscount !== -1
												? styles.textDecorationLineThrough
												: ""
										}
									/>
									{props.discount !== -1 && (
										<RxTypography
											component="span"
											variant="body1"
											align="center"
											label={
												"  >  " +
												calculatePrice(item, true).toFixed(2) +
												" TL"
											}
											className={styles.bold}
										/>
									)}
								</TableCell>
							</TableRow>
						);
					})}
				</TableBody>
			</Table>
			{!isNullOrUndefined(props.kdvIncluded) && (
				<RxTypography
					component="span"
					variant="subtitle2"
					align="center"
					label={
						props.kdvIncluded
							? "Fiyatlara KDV dahildir."
							: "Fiyatlara KDV dahil değildir."
					}
				/>
			)}
		</>
	);
};

export default RxProductPriceDetail;
